<template>
  <div class="trade-order-list-view" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="商城订单" :showBack="true"></my-header>
    <div class="general-tab-part trade-tab-part">
      <div class="tab-item" @click = "change('')" :class="{'selected':orderTradeStatus == ''}">全部订单</div>
      <div class="tab-item" @click = "change('1')" :class="{'selected':orderTradeStatus == '1'}">待支付</div>
      <div class="tab-item" @click = "change('2')" :class="{'selected':orderTradeStatus == '2'}">已支付</div>
      <div class="tab-item" @click = "change('3')" :class="{'selected':orderTradeStatus == '3'}">申请售后</div>
    </div>
    <div class="trade-order-list">
      <div v-if="orderList.length>0" v-for="item in orderList" class="customer-cart-item general-box-shadow">
        <div class="shop-info border-bottom-style">
          <div @click="toShopDetail(item.shopId)" class="shop-name">{{item.shopName}}</div>
          <div style="color: #feac00;font-size: 0.32rem">{{orderStatusMap[item.status]}}</div>
        </div>
        <div v-for="(orderDetailItem,orderDetailIndex) in item.detailList" @click="toProductDetail(orderDetailItem.productId,item.shopId)" class="product-info">
          <img class="product-img" :src="orderDetailItem.image">
          <div class="product-sku">
            <div class="product-name">{{orderDetailItem.name}}</div>
            <div class="sku-item">数量：{{orderDetailItem.quantity}}</div>
            <div class="single-price">￥{{orderDetailItem.price}}</div>
          </div>
        </div>
        <div class="bottom-price">
          <div class="product-word">实付：</div>
          <div class="product-price">￥{{item.price}}</div>
        </div>
        <div class="trade-order-operation">
          <div v-if = "item.status == '1'" class="general-btn" @click = "cancelOrder(item.id)">取消订单</div>
          <div class="general-btn" v-if = "item.status == '2'" @click = "toOrderRefund(item.id,item.payTime)">申请退款</div>
          <div v-if = "item.status == '1'" class="general-btn pay-btn" @click="payOrder(item.id)">去支付</div>
        </div>
      </div>
    </div>
    <div class="black-page" v-if="orderList.length == 0">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">还没有订单哦</div>
    </div>
    <div v-if="isCancelOrder" class="toast general-trade-modal general-box-shadow">
      <div class="general-trade-modal-text">确定要取消订单?</div>
      <div class="confirm-footer" >
        <div class="agree-btn" @click="confirmCancel">确定</div>
        <div class="cancel-btn" @click = "cancel">取消</div>
      </div>
    </div>
    <div v-if="isCancelOrder" class="general-box-bg"></div>

    <div v-if="isPayOrder" class="toast general-trade-modal general-box-shadow">
      <div class="general-trade-modal-text">确定要支付订单?</div>
      <div class="confirm-footer" >
        <div class="agree-btn" @click="payTraderOrder">确定</div>
        <div class="cancel-btn" @click = "cancelPay">取消</div>
      </div>
    </div>
    <div v-if="isPayOrder" class="general-box-bg"></div>

    <div v-if="isContactService" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelContactService()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">您的订单已超过退款期限，<br/>请联系客服进行退款。<br/>客服电话：4000600566</div>
      <div class="agree-btn" @click="contactService()">联系客服</div>
    </div>
    <div v-if="isContactService" class="pay-box"></div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import {imgUrl} from "../../config";
  import payUtil from '../../utils/Pay'
  import tradeOrderService from '../../service/trade/TradeOrderService'

  export default {
    name: 'TradeOrderList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        prePayInfo:{},
        imgUrl: imgUrl,
        orderTradeStatus:'',
        orderList:[],
        pageNo:1,
        orderStatusMap:[],
        isCancelOrder:false,
        isPayOrder:false,
        operationOrderId:'',
        isWechatBrowser:this.$verfyBrowserType(),
        isContactService: false
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.loadTradeOrderList();
      if (this.global.orderTradeStatus) {
        this.orderTradeStatus = this.global.orderTradeStatus;
        this.global.orderTradeStatus = '';
      }
    },
    methods: {
      change(status){
        this.orderTradeStatus = status;
        this.orderList = [];
        this.loadTradeOrderList();
      },
      async loadTradeOrderList(){
        let {code,msg,data} = await tradeOrderService.list(this.orderTradeStatus,this.pageNo);
        if(code == '0'){
          this.orderList = data.orderList;
          this.orderStatusMap = data.orderStatusMap;
        }else {
          Toast(msg);
        }
      },
      //跳转订单详情
      toOrderDetail(tradeOrderId){
        this.global.orderTradeStatus = this.orderTradeStatus;
        this.$router.push({name: 'TradeOrderDetail', query: {tradeOrderId}})
      },
      //跳转店铺详情
      toShopDetail(id){
        this.$router.push({name: 'ShopDetail', query: {shopId:id}})
      },
      toProductDetail(productId,shopId){
        this.$router.push({name: 'ProductDetail', query: {productId,shopId}})
      },
      cancelOrder(id){
        this.operationOrderId = id;
        this.isCancelOrder = true;
      },
      cancel(){
        this.isCancelOrder = false;
      },
      async confirmCancel(){
        tradeOrderService.cancelOrder(this.operationOrderId).then(res =>{
          if(res.code == '0'){
             Toast('取消订单成功!');
            this.loadTradeOrderList();
            this.isCancelOrder = false;
          }else{
            Toast(res.msg);
          }
        })
      },
      payOrder(id){
        this.operationOrderId = id;
        this.isPayOrder = true;
      },
      cancelPay(){
        this.isPayOrder = false;
      },
      //申请退款
      toOrderRefund(tradeOrderId,payTime){
          var payDate = new Date(payTime);
          var now = new Date();
          var day = 24 * 60 * 60 * 1000;
          var diffDay = (now - payDate) / day;
          if(diffDay.toFixed(0) > 365){
              this.isContactService = true;
          }else {
              this.global.orderTradeStatus = this.orderTradeStatus;
              this.$router.push({name: 'OrderRefund', query: {tradeOrderId}})
          }
      },
      async payTraderOrder(){
        //判断浏览器类型
        var ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger') {
          //微信浏览器
          let result = await tradeOrderService.payOrder(this.operationOrderId,'1');
          if(result.code == '0'){
              this.prePayInfo = payUtil.pay(result.data.prepayId,result.data.nonceStr);
              let requestPay = this.requestPay;
              if (typeof WeixinJSBridge == "undefined"){
                if( document.addEventListener ){
                  document.addEventListener('WeixinJSBridgeReady', requestPay, false);
                }else if (document.attachEvent){
                  document.attachEvent('WeixinJSBridgeReady', requestPay);
                  document.attachEvent('onWeixinJSBridgeReady', requestPay);
                }
              }else{
                this.requestPay();
              }
            } else {
              Toast(result.msg);
            }
        }else {
          //非微信浏览器
          let result = await tradeOrderService.payOrder(this.operationOrderId);
          if(result.code == '0'){
            let payCallBackUrl = result.data.mwebUrl + '&redirect_url=' + window.location.href;
            window.location.href = payCallBackUrl;
          }else {
            Toast(result.msg);
          }
        }
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.loadTradeOrderList();
                that.isPayOrder = false;
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
              that.isPayOrder = false;
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .trade-order-list-view {
    font-size: 0.32rem;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    text-align: left;
    background-color: white;
    .trade-tab-part{
      position: fixed;
      height: 0.9rem;
      width: 100%;
      line-height: 0.9rem;
      background: white;
      font-size: 0.32rem;
      z-index: 1;
      .selected{
        font-size: 0.36rem;
        font-weight: bold
      }
    }
    .trade-order-list{
      padding-top: 0.92rem;
      .customer-cart-item{
        background-color: white;
        width: 6.9rem;
        margin: 0rem 0.3rem 0.2rem;
        .product-info{
          display:flex;
          position:relative;
          width: 6.3rem;
          margin: 0 auto 0.3rem;
          .product-img{
            width: 2.3rem;
            height: 2.3rem;
            border-radius: 0.06rem;
            margin-top: 0.32rem;
          }
          .product-sku{
            width: 5rem;
            padding-left: 0.3rem;
            .product-name{
              height: 0.8rem;
              line-height: 0.4rem;
              margin-top: 0.25rem;
              text-align: justify;
              font-size: 0.32rem;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow : hidden;
              word-break: break-all;
            }
            .sku-item{
              margin-top: 0.2rem;
              font-size: 0.28rem;
              color: #7f7d7c;
            }
            .single-price{
              margin-top: 0.45rem;
              font-size: 0.4rem;
              color: #d54a33;
              font-weight: bold;
            }
          }
        }
        .bottom-price{
          display: flex;
          justify-content: flex-end;
          height: 0.8rem;
          line-height: 0.7rem;
          margin-right: 0.27rem;
          padding-top: 0.2rem;
          font-weight: bold;
        }
        .product-price{
          font-size: 0.4rem;
          color: #d54a33;
        }
        .trade-order-operation{
          font-size: 0.28rem;
          padding: 0.28rem 0;
          display: flex;
          justify-content: flex-end;
          .general-btn{
            margin-left: 0.2rem;
          }
        }
      }
    }
    .shop-info{
      width: 6.3rem;
      display: flex;
      justify-content: space-between;
      position: relative;
      padding-top: 0.3rem;
      padding-bottom: 0.36rem;
      margin-left: 0.3rem;
      .shop-name{
        font-size: 0.32rem;
        color: #7f7d7c;
      }
    }
  }
</style>
